import { DataEntryStateEnum } from '../enums';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';

export class CounterWidgetDataEntryPresenterModel {
  id?: string;
  entityVersion?: number;
  specificationVersion?: number;
  dataEntity: string;
  state: DataEntryStateEnum;

  moduleName: LocalizedValueModel;
  viewName: LocalizedValueModel;
  icon: IconModel;
  /**
   * The module id this data view belongs to
   */
  moduleId: string;
  /**
   * The data entity id this data view belongs to
   */
  viewDataEntity: string;
  /**
   * The reference property to the view
   * { dataEntity: 'DataViews', dataEntry: 'uuid-for-the-data-view' }
   */
  view: RefProperty;
  /**
   * The display order of the counter in the top bar.
   */
  displayOrder: number;

  query: RefProperty;

  name: LocalizedValueModel;
  description: LocalizedValueModel;
}
